import api from '../../api/_examen'

const state = () => ({
    examens: [],
    examens_selected: [],
    demande_examen_para: [],
    examen_para_historique: [],
    registre_examen: [],
    examen_to_flll: [],
    examen_salle_attente: [],
    bulletin_examens: [],
    bulletin_examen_historique: [],
    selected_date_filter: {}
})

// getters
const getters = {
    examens: (state) => {
        return state.examens
    },

    examens_selected: (state) => {
        return state.examens_selected
    },

    demande_examen_para: (state) => {
        return state.demande_examen_para
    },

    examen_para_historique: (state) => {
        return state.examen_para_historique
    },

    registre_examen: (state) => {
        return state.registre_examen
    },

    examen_to_flll: (state) => {
        return state.examen_to_flll
    },

    examen_salle_attente: (state) => {
        return state.examen_salle_attente
    },

    bulletin_examens: (state) => {
        return state.bulletin_examens
    },

    bulletin_examen_historique: (state) => {
        return state.bulletin_examen_historique
    },

    selected_date_filter: (state) => {
        return state.selected_date_filter
    },
}
// mutations
const mutations = {
    SET_EXAMENS(state, exam) {
        state.examens = exam
    },

    SET_EXAMENS_SELECTED(state, exam) {
        state.examens_selected = exam
    },

    SET_DEMANDE_EXAMENS(state, demande_examen_para) {
        state.demande_examen_para = demande_examen_para
    },

    SET_DEMANDE_EXAMENS_HISTORIQUE(state, examen_para) {
        state.examen_para_historique = examen_para
    },

    SET_REGISTRE_EXAMEN(state, examen_para) {
        state.registre_examen = examen_para
    },

    SET_EXAMEN_TO_FILL(state, examen_para) {
        state.examen_to_flll = examen_para
    },

    SET_EXAMEN_SALLE_ATTENTE(state, examen_para) {
        state.examen_salle_attente = examen_para
    },

    SET_BULLETIN_EXAMENS(state, bulletin) {
        state.bulletin_examens = bulletin
    },

    SET_BULLETIN_EXAMENS_HISTORIQUE(state, bulletin) {
        state.bulletin_examen_historique = bulletin
    },

    SET_SELECTED_DATE_FILTER(state, date_filter) {
        state.selected_date_filter = date_filter
    },
}

// actions
const actions = {
    getExamens({ commit }) {
        api.getExamens().then(
            response => {
                commit('SET_EXAMENS', response)
            }
        )
    },
    getExamensMiniInfo({commit}){
        return new Promise((resolve,reject) => {
            api.getExamensMiniInfo().then(
                response =>{
                    resolve(response)
                    commit('SET_EXAMENS', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    searchExamen({commit}, search_word){
       return new Promise((resolve, reject) =>{
           api.searchExamen(search_word).then(
               response => {
                   resolve(response)
                   commit('SET_EXAMENS',response)
               }, error => {
                   reject(error)
               }
           )
       })
    },

    getDemandeExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getDemandeExamen(data).then(
                response => {
                    if (data.enCours === true) {
                        commit('SET_DEMANDE_EXAMENS', response)
                    } else {
                        commit('SET_DEMANDE_EXAMENS_HISTORIQUE', response)
                    }
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveDemandeExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveDemandeExamen(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    editExamenRenseignementClinique({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.editExamenRenseignementClinique(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteDemandeExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteDemandeExamen(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteExamenBulletin({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.deleteExamenBulletin(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    addNewExamen({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.addNewExamen(data).then(
                response => {
                    dispatch('getExamens')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveResultatExamen({ commit }, data) {
        return new Promise((resolve,reject) =>{
            api.saveResultatExamen(data).then(
                response => {
                    commit
                    resolve(response)
                },error => {
                    reject(error)
                }
            )
        })
    },

    getRegistreExamen({commit}, user_id){
        return new Promise((resolve,reject) => {
            api.getRegistreExamen(user_id).then(
                response =>{
                    resolve(response)
                    commit('SET_REGISTRE_EXAMEN', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getExamenToFill({commit}, data){
        return new Promise((resolve,reject) => {
            api.getExamenToFill(data).then(
                response =>{
                    resolve(response)
                    commit('SET_EXAMEN_TO_FILL', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getExamenSalleAttente({commit}, data){
        return new Promise((resolve,reject) => {
            api.getExamenSalleAttente(data).then(
                response =>{
                    resolve(response)
                    commit('SET_EXAMEN_SALLE_ATTENTE', response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteTypeExamen({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteTypeExamen(data).then(
                response => {
                    dispatch('getExamens')
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getBulletinExamen({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getBulletinExamen(data).then(
                response => {
                    if (data.est_encours === true) {
                        commit('SET_BULLETIN_EXAMENS', response)
                    } else {
                        commit('SET_BULLETIN_EXAMENS_HISTORIQUE', response)
                    }
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}